export default "__VITE_ASSET__629ce0b7__"